import { Field, Form, Formik } from 'formik';
import React from 'react';

import { PessoaSchema } from '../../utils/validations';
import { FormInput, SaveButton } from '../Inspinia';

const Formulario = ({ initialValues, onSubmit }) => {
  const handleSubmit = (values, { setSubmitting }) => {
    onSubmit(values, () => setSubmitting(false));
  };

  return (
    <Formik
      onSubmit={handleSubmit}
      validationSchema={PessoaSchema}
      initialValues={initialValues}
      enableReinitialize
    >
      {props => (
        <Form onSubmit={props.handleSubmit}>
          <div className="row">
            <Field
              component={FormInput}
              name="cpf"
              label="CPF:"
              col={4}
              mask="999.999.999-99"
              required
            />

            <Field component={FormInput} name="nome" label="Nome:" col={8} required />
          </div>

          <div className="row">
            <Field component={FormInput} name="cep" label="CEP:" col={3} mask="99999-999" />

            <Field component={FormInput} name="logradouro" label="Endereço:" col={6} />

            <Field component={FormInput} name="numero" label="Número:" col={3} />
          </div>

          <div className="row">
            <Field component={FormInput} name="complemento" label="Complemento:" col={6} />

            <Field component={FormInput} name="bairro" label="Bairro:" col={6} />
          </div>

          <div className="row">
            <Field
              component={FormInput}
              name="telefoneFixo"
              label="Telefone:"
              col={6}
              mask="(99)9999-9999"
            />

            <Field
              component={FormInput}
              name="telefoneCelular"
              label="Celular:"
              col={6}
              mask="(99)99999-9999"
            />
          </div>

          <div className="row">
            <div className="col-md-12">
              <SaveButton loading={props.isSubmitting} />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default Formulario;
